import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'cointrader_lang';

const resources = {
  en: {
    translation: {
      'lang.en': 'English',
      'lang.zh': '中文',
      'user.title': 'User Login',
      'user.login': 'Login',
      'user.mustChange': 'You must change your password first.',
      'user.updatePwd': 'Update password',
      'user.username': 'Username',
      'user.password': 'Password',
      'user.newPassword': 'New password',
      'user.signedIn': 'Signed in successfully.',
      'user.changedOk': 'Password updated. Please sign in again.',
      'user.logout': 'Sign out',
      'home.title': 'My wallets',
      'home.loading': 'Loading…',
      'home.forbiddenAdmin': 'Wallet home is for normal users only. Sign out and use a user account.',
      'home.walletListSubtitle': 'Wallets on this account.',
      'home.walletEmptyHint': 'Add your first wallet below. If you have not set a payment password yet, open Settings first.',
      'home.settingsLink': 'Settings',
      'home.addWalletFold': 'Add another wallet',
      'home.createModeNew': 'Generate new',
      'home.createModeImport': 'Import private key',
      'home.importKeyPh': 'Private key (32-byte hex, optional 0x)',
      'home.importKeyRequired': 'Enter the private key to import.',
      'home.needPaymentGoSettings': 'Set a payment password in Settings before you can create wallets.',
      'home.openSettings': 'Open Settings',
      'home.walletNoEvmAddr': '—',
      'home.copyEvmAddress': 'Copy address',
      'home.evmAddressCopied': 'Copied',
      'home.copyFailed': 'Could not copy. Select the address manually, or open this site over HTTPS.',
      'home.source.stub': 'stub',
      'home.source.mpc': 'mpc',
      'home.source.import': 'import',
      'home.stubSection': 'Development: stub wallet',
      'home.stubHint': 'Enable wallet.mpc_stub in server config. Not real cryptography.',
      'home.stubName': 'Wallet name',
      'home.createStub': 'Create stub wallet',
      'home.createWalletTitle': 'New wallet',
      'home.createWalletHint': 'Pick a name for this wallet. Keys are generated securely in your browser.',
      'home.createWalletNamePh': 'Wallet name',
      'home.createWalletPayPh': 'Payment password',
      'home.createWalletSubmit': 'Create wallet',
      'home.creatingWallet': 'Creating…',
      'home.walletCreatedOk': 'Wallet created.',
      'home.walletCreatedFull': 'Done. “{{name}}” is in the list below.',
      'home.walletNameRequired': 'Please enter a wallet name.',
      'home.walletListEmpty': 'No wallets yet.',
      'home.showHiddenWallets': 'Show hidden wallets',
      'home.walletHideFromHomeList': 'Hide from home list',
      'home.walletActions': 'Wallet actions',
      'home.walletMoveTop': 'Move to top',
      'home.walletMoveBottom': 'Move to bottom',
      'home.walletHiddenBadge': 'Hidden',
      'home.walletAllHiddenInList': 'Every wallet is hidden from this list.',
      'home.walletAllHiddenHint': 'Turn on “Show hidden wallets” above to see them.',
      'home.mpcDisabledHint': 'Wallet creation is temporarily unavailable. Contact support if this continues.',
      'home.walletName': 'Wallet name',
      'home.refresh': 'Refresh',
      'wallet.backHome': 'Back to wallets',
      'wallet.invalidId': 'Invalid wallet link.',
      'wallet.evmAddress': 'EVM address',
      'wallet.rippleAddress': 'Ripple address',
      'wallet.xrpBalance': 'XRP balance',
      'wallet.ripple.disableMasterKey': 'DisableMasterKey',
      'wallet.ripple.regularKeyOnLedger': 'RegularKey (on ledger)',
      'wallet.rippleUnavailable': 'Ripple address is not available for this wallet.',
      'wallet.type': 'Wallet type',
      'wallet.type.evm': 'EVM',
      'wallet.type.ripple': 'Ripple',
      'wallet.type.bitcoin': 'Bitcoin',
      'wallet.bitcoinComingSoon': 'Bitcoin support is coming soon.',
      'wallet.ripple.transferTitle': 'Transfer',
      'wallet.ripple.sourceAddress': 'Source address (optional)',
      'wallet.ripple.sourceAddressPh': 'Empty = this wallet account',
      'wallet.ripple.destination': 'Destination',
      'wallet.ripple.amountXrp': 'Amount (XRP)',
      'wallet.ripple.destinationTag': 'Destination tag',
      'wallet.ripple.optional': 'Optional',
      'wallet.ripple.paymentPassword': 'Payment password',
      'wallet.ripple.transferSubmit': 'Sign & submit transfer',
      'wallet.ripple.setRegularKeyTitle': 'Set RegularKey',
      'wallet.ripple.regularKey': 'RegularKey address',
      'wallet.ripple.setRegularKeySubmit': 'Sign & set RegularKey',
      'wallet.ripple.disableMasterTitle': 'Disable MasterKey',
      'wallet.ripple.disableMasterHint': 'Requires an on-chain RegularKey to be set first.',
      'wallet.ripple.disableMasterSubmit': 'Sign & disable MasterKey',
      'wallet.ripple.submitting': 'Submitting…',
      'wallet.ripple.payPwdRequired': 'Enter payment password.',
      'wallet.ripple.destinationRequired': 'Enter destination address.',
      'wallet.ripple.amountRequired': 'Enter XRP amount.',
      'wallet.ripple.regularKeyRequired': 'Enter RegularKey address.',
      'wallet.ripple.tagInvalid': 'Destination tag must be a uint32 integer.',
      'wallet.ripple.submitted': 'Ripple transaction submitted.',
      'wallet.ripple.txHash': 'Transaction hash',
      'wallet.renamePlaceholder': 'New wallet name',
      'wallet.renameSubmit': 'Rename',
      'wallet.renameBusy': 'Renaming…',
      'wallet.renameRequired': 'Please enter a wallet name.',
      'wallet.renameSuccess': 'Wallet name updated.',
      'wallet.renameDoubleClickHint': 'Double-click to rename',
      'wallet.watchedTokens': 'Watched tokens',
      'wallet.watchedHint':
        'Choose the chain, then leave the field empty for the native gas token, open the list for catalog tokens, or paste an ERC-20 contract address. Balances use multiple public RPCs per chain (see config.yaml); two endpoints are chosen at random per request.',
      'wallet.addToken': 'Add',
      'wallet.contractChainLabel': 'Chain',
      'wallet.tokenOrContractLabel': 'Token or contract',
      'wallet.tokenComboboxPh': 'Empty = native · ▾ catalog · or 0x + 40 hex',
      'wallet.openTokenCatalog': 'Open token catalog',
      'wallet.catalogEmptyForChain': 'All catalog tokens on this chain are already watched.',
      'wallet.catalogNoMatch': 'No catalog match — type a contract address or clear the filter.',
      'wallet.tokenInputInvalid': 'Enter a valid non-zero 40-character hex address (with or without 0x), pick from the catalog, or leave empty for native.',
      'wallet.pickedTokenStale': 'Selection no longer matches this chain — pick again or type an address.',
      'wallet.tokenAdded': 'Added to watch list.',
      'wallet.tokenRemoved': 'Removed from watch list.',
      'wallet.colTokenChain': 'Token / chain',
      'wallet.colBalance': 'Balance',
      'wallet.balanceLoading': 'Loading…',
      'wallet.refreshBalances': 'Refresh balances',
      'wallet.watchedListLoading': 'Loading watch list…',
      'wallet.colActionSr': 'Actions',
      'wallet.noTokensYet': 'No tokens yet. Add one above.',
      'wallet.remove': 'Remove',
      'wallet.explorerTitle': 'Open in block explorer',
      'wallet.explorerHint': 'Choose a network. The same address is used on each EVM chain.',
      'wallet.qr.scanWalletConnect': 'Scan WalletConnect QR',
      'wallet.qr.scanHint': 'Scan the dApp WalletConnect QR code with your camera.',
      'wallet.qr.manualInput': 'WalletConnect URI (manual input)',
      'wallet.qr.confirmWalletConnect': 'Pair WalletConnect',
      'wallet.qr.walletConnectInvalid': 'Invalid WalletConnect URI. Must start with wc:.',
      'wallet.qr.walletConnectDetected': 'WalletConnect URI detected and paired.',
      'wallet.qr.walletConnectProjectMissing':
        'WalletConnect project ID is missing. Set VITE_WALLETCONNECT_PROJECT_ID in web/.env.production and rebuild.',
      'wallet.qr.walletConnectPairFailed': 'WalletConnect pairing failed. Please retry or use another QR code.',
      'wallet.qr.walletConnectSessionTitle': 'WalletConnect session request',
      'wallet.qr.walletConnectSessionHint': 'Review dApp and requested capabilities before approving.',
      'wallet.qr.walletConnectDapp': 'dApp',
      'wallet.qr.walletConnectMethods': 'Requested methods',
      'wallet.qr.walletConnectChains': 'Chains to approve',
      'wallet.qr.walletConnectActiveChain': 'Active chain for this session',
      'wallet.qr.walletConnectActiveChainHint':
        'dApps use this as the current chain. They can also request a switch later via wallet_switchEthereumChain.',
      'wallet.qr.walletConnectNoSupportedChains':
        'This dApp requires chains that this wallet does not support. Reject the session or reconnect from a supported network.',
      'wallet.qr.walletConnectChainSwitched': 'WalletConnect active chain switched for this session.',
      'wallet.qr.walletConnectChainUnsupported': 'Requested chain is not supported or not included in this session.',
      'wallet.qr.walletConnectChainMismatch':
        'Signature chain mismatch: typed-data domain.chainId does not match the WalletConnect request chain. Ask the dApp to switch chain, or reconnect with the correct active chain.',
      'wallet.qr.walletConnectSessionApproved': 'WalletConnect session approved.',
      'wallet.qr.walletConnectSessionRejected': 'WalletConnect session rejected.',
      'wallet.qr.walletConnectSessionApproveFailed': 'Failed to handle WalletConnect session request.',
      'wallet.qr.walletConnectRequestTitle': 'WalletConnect signature request',
      'wallet.qr.walletConnectRequestPayload': 'Signing payload (raw)',
      'wallet.qr.walletConnectRequestApproved': 'WalletConnect request signed and sent.',
      'wallet.qr.walletConnectRequestRejected': 'WalletConnect request rejected.',
      'wallet.qr.walletConnectRequestApproveFailed': 'Failed to sign WalletConnect request.',
      'wallet.qr.walletConnectMethodUnsupported': 'Unsupported WalletConnect method for this wallet.',
      'wallet.qr.reject': 'Reject',
      'wallet.qr.approve': 'Approve',
      'wallet.qr.approveAndSign': 'Approve and sign',
      'wallet.qr.cameraStartFailed': 'Cannot start camera scanning. Please check camera permission or paste wc URI manually.',
      'wallet.close': 'Close',
      'tokenDetail.backWallet': 'Back to wallet',
      'tokenDetail.badRoute': 'Invalid token link.',
      'tokenDetail.nativeLabel': 'Native',
      'tokenDetail.metaTitle': 'Token details',
      'tokenDetail.name': 'Name',
      'tokenDetail.symbol': 'Symbol',
      'tokenDetail.decimals': 'Decimals',
      'tokenDetail.contract': 'Contract',
      'tokenDetail.nativeNoContract': '— (native gas token)',
      'tokenDetail.balance': 'Balance',
      'tokenDetail.usdPrice': 'USD price',
      'tokenDetail.usdPriceLoading': 'Loading…',
      'tokenDetail.allowanceTitle': 'Allowance',
      'tokenDetail.allowanceHint': 'Amount the selected spender is allowed to move. Default spender is the in-app Exchange contract (same address on each supported chain).',
      'tokenDetail.refreshAllowance': 'Refresh',
      'tokenDetail.spender': 'Spender (contract)',
      'tokenDetail.approveTitle': 'Approve',
      'tokenDetail.approveUnlimited': 'Unlimited approval (max uint256)',
      'tokenDetail.approveAmountPh': 'Amount to approve (token units)',
      'tokenDetail.approveAmountRequired': 'Enter an amount or choose unlimited approval.',
      'tokenDetail.approveSubmit': 'Sign & submit approval',
      'tokenDetail.approveOk': 'Approval transaction submitted.',
      'tokenDetail.wrapTitle': 'Wrap (deposit native)',
      'tokenDetail.wrapHint': 'Send native coin to the wrapped contract to receive the wrapped ERC-20 (e.g. ETH → WETH).',
      'tokenDetail.wrapAmountPh': 'Amount to wrap (e.g. 0.1)',
      'tokenDetail.wrapSubmit': 'Sign & wrap',
      'tokenDetail.wrapOk': 'Wrap transaction submitted.',
      'tokenDetail.unwrapTitle': 'Unwrap (withdraw to native)',
      'tokenDetail.unwrapHint': 'Burn wrapped tokens to receive native currency on this chain.',
      'tokenDetail.unwrapAmountPh': 'Amount to unwrap',
      'tokenDetail.unwrapSubmit': 'Sign & unwrap',
      'tokenDetail.unwrapOk': 'Unwrap transaction submitted.',
      'tokenDetail.submitting': 'Signing…',
      'wallet.chain.ethereum': 'Ethereum',
      'wallet.chain.sepolia': 'Sepolia',
      'wallet.chain.bsc': 'BNB Chain',
      'wallet.chain.base': 'Base',
      'wallet.chain.avax': 'Avalanche C-Chain',
      'wallet.chain.polygon': 'Polygon',
      'wallet.chain.arb': 'Arbitrum One',
      'wallet.chain.op': 'Optimism',
      'wallet.chain.ripple': 'Ripple',
      'wallet.chain.bitcoin': 'Bitcoin',
      'swap.nav': 'Swap',
      'swap.title': 'Swap quote',
      'swap.subtitle':
        'Pick a wallet, chain, and tokens from the catalog. The server queries gas price and multiple DEX endpoints per chain (Uniswap V2–style routers, V3 QuoterV2, and official Uniswap V4 Quoter where deployed). Rows without liquidity show an error.',
      'swap.backHome': 'Back to wallets',
      'swap.selectWallet': 'Wallet',
      'swap.walletPlaceholder': 'Choose a wallet…',
      'swap.chain': 'Network',
      'swap.tokenIn': 'Sell',
      'swap.tokenOut': 'Buy',
      'swap.amountIn': 'Amount to sell',
      'swap.sellBalance': 'Balance',
      'swap.sellBalanceLoading': 'Loading balance…',
      'swap.slippage': 'Slippage tolerance',
      'swap.slippageBps': '{{bps}} basis points (100 = 1%)',
      'swap.slippageHint': 'Used to compute minimum received (min out) next to each quote.',
      'swap.getQuote': 'Get quotes',
      'swap.quoting': 'Querying…',
      'swap.quoteOk': 'Quotes updated.',
      'swap.resultsTitle': 'DEX comparison',
      'swap.gasPrice': 'Suggested gas price',
      'swap.amountInSummary': 'Size',
      'swap.colProtocol': 'Protocol',
      'swap.colOut': 'Est. received',
      'swap.colMinOut': 'Min. out (after slippage)',
      'swap.colLiquidity': 'Liquidity',
      'swap.colNote': 'Note / error',
      'swap.openPoolInExplorer': 'View pool contract on block explorer',
      'swap.colAction': 'Action',
      'swap.swapExecute': 'Swap',
      'swap.swapBusy': 'Signing…',
      'swap.payPassword': 'Payment password',
      'swap.payPasswordHint': 'Required to sign the swap transaction with MPC in your browser.',
      'swap.payPasswordRequired': 'Enter payment password to swap.',
      'swap.swapSubmitted': 'Swap submitted.',
      'swap.swapFeeRow': 'Tx gas (Gwei)',
      'swap.swapCannotRow': 'This row has no executable quote.',
      'transfer.nav': 'Transfer',
      'transfer.title': 'Transfer',
      'transfer.subtitle':
        'Pick wallet, network, recipient, and token. The app prepares an EIP-1559 transaction digest, signs it with MPC in your browser, then submits the signed transaction through the backend RPC.',
      'transfer.backHome': 'Back to wallets',
      'transfer.selectWallet': 'Wallet',
      'transfer.walletPlaceholder': 'Choose a wallet…',
      'transfer.chain': 'Network',
      'transfer.toAddress': 'Recipient address',
      'transfer.token': 'Token',
      'transfer.amount': 'Amount',
      'transfer.balance': 'Balance',
      'transfer.balanceLoading': 'Loading balance…',
      'transfer.maxFee': 'Max fee (Gwei)',
      'transfer.priorityFee': 'Priority fee (Gwei)',
      'transfer.baseFeeLine': 'Current base fee: {{gwei}} Gwei',
      'transfer.nonce': 'Nonce',
      'transfer.nonceHint': 'Auto-filled from the network; you can override with a custom value.',
      'transfer.nonceInvalid': 'Invalid nonce. Use a non-negative integer.',
      'transfer.nonceLoadError': 'Could not load suggested nonce.',
      'transfer.paymentPassword': 'Payment password',
      'transfer.payPwdUnlockHint': 'Payment password verified for this login session — leave blank to reuse.',
      'transfer.paymentPasswordRequired': 'Enter payment password.',
      'transfer.sessionMissing': 'Wallet client session is missing on this device.',
      'transfer.sessionInvalid': 'Wallet client session is invalid.',
      'transfer.submit': 'Submit transfer',
      'transfer.submitting': 'Submitting…',
      'transfer.submitted': 'Transfer submitted.',
      'transfer.txHash': 'Transaction hash',
      'transfer.txJsonTitle': 'Constructed transaction (unsigned)',
      'transfer.txJsonHint': 'EIP-1559 fields and signing digest from the server. Review before the signature step runs in your browser.',
      'proxyTransfer.nav': 'Proxy transfer',
      'proxyTransfer.title': 'Proxy transfer (EIP-7702)',
      'proxyTransfer.subtitle':
        'Multi-token atomic payout in one EIP-7702 (type-4) transaction. Pick catalog tokens on this network, enter the source EOA private key (used only in your browser to sign), leave amounts blank to send full on-chain balance for each token.',
      'proxyTransfer.sourceKey': 'Source address private key',
      'proxyTransfer.sourceKeyPh': '0x… (64 hex chars)',
      'proxyTransfer.toPlaceholder': 'Empty = current wallet address',
      'proxyTransfer.toDefaultHint': 'If left empty, recipient defaults to this wallet: {{address}}',
      'proxyTransfer.keyWarning':
        'Never share this key. It is kept in this browser tab for signing only and is not sent to the server.',
      'proxyTransfer.rowsTitle': 'Outbound tokens',
      'proxyTransfer.addRow': 'Add token',
      'proxyTransfer.noWatched': 'No catalog tokens on this network.',
      'proxyTransfer.amountOptional': 'Amount (optional)',
      'proxyTransfer.amountPlaceholder': 'Empty = full balance',
      'proxyTransfer.removeRow': 'Remove',
      'proxyTransfer.privateKeyInvalid': 'Enter a valid 32-byte hex private key.',
      'proxyTransfer.needRow': 'Add at least one token row.',
      'proxyTransfer.authNonceMissing': 'Could not load source-address nonce for delegation authorization.',
      'proxyTransfer.authNonceHint': 'Delegation auth nonce (source address): {{nonce}}',
      'proxyTransfer.submitting': 'Signing & submitting…',
      'proxyTransfer.submit': 'Sign and submit',
      'proxyTransfer.submitted': 'Proxy transfer submitted.',
      'proxyTransfer.lastPrepare': 'Last prepare response (signing failed)',
      'settings.title': 'Settings',
      'settings.back': 'Back to wallets',
      'settings.loginPwdTitle': 'Login password',
      'settings.loginPwdHint': 'Used to sign in. You stay signed in after updating.',
      'settings.newLoginPwdPh': 'New login password',
      'settings.saveLoginPwd': 'Update login password',
      'settings.loginPwdSaved': 'Login password updated.',
      'settings.payTitle': 'Payment password',
      'settings.payIntro':
        'Used on this device to encrypt wallet keys. The server stores only a secure hash—not the password itself.',
      'settings.payIntroFirst':
        'Choose a payment password to encrypt wallet keys in your browser. You must set this before creating wallets; the server never stores the plaintext.',
      'settings.payFirstBanner': 'You have not set a payment password yet. Set it here, then return to wallets to create one.',
      'settings.payCurrentPh': 'Current payment password',
      'settings.payNewPh': 'New payment password',
      'settings.paySetPh': 'Payment password',
      'settings.payConfirmPh': 'Confirm payment password',
      'settings.payMismatch': 'The two passwords do not match.',
      'settings.savePayPwd': 'Save payment password',
      'settings.savePayPwdFirst': 'Set payment password',
      'settings.payPwdSaved': 'Payment password saved.',
      'settings.payPwdSavedFirst': 'Payment password is set. You can create a wallet now.',
      'settings.payReencryptSessionFailed': 'Could not load encrypted wallet data from the server.',
      'settings.payReencryptMissingSecret': 'Wallet data is incomplete on the server; contact support.',
      'settings.payReencryptFail': 'Could not decrypt wallet data with the current payment password.',
      'admin.title': 'Admin',
      'admin.loginTitle': 'Admin login',
      'admin.login': 'Login',
      'admin.mustChange': 'You must change the admin password first.',
      'admin.updatePwd': 'Update password',
      'admin.adminPwd': 'Admin password',
      'admin.newPassword': 'New password',
      'admin.userList': 'User list',
      'admin.addUser': 'Add user',
      'admin.initialPwd': 'Initial password',
      'admin.create': 'Create user',
      'admin.logout': 'Sign out',
      'admin.goUser': 'User login',
      'admin.thId': 'ID',
      'admin.thUser': 'Username',
      'admin.thRole': 'Role',
      'admin.thMust': 'Must change',
      'admin.thCreated': 'Created at',
      'admin.roleAdmin': 'Admin',
      'admin.roleUser': 'User',
      'admin.thBanned': 'Suspended',
      'admin.actions': 'Actions',
      'admin.ban': 'Suspend',
      'admin.unban': 'Activate',
      'admin.resetPwd': 'Reset password',
      'admin.resetPwdTitle': 'Reset password for {{name}}',
      'admin.resetPwdHint': 'New password',
      'admin.resetPwdSubmit': 'Save',
      'admin.resetPwdCancel': 'Cancel',
      'admin.thMfa': '2FA',
      'admin.mfaSetup': 'Set up 2FA',
      'admin.mfaRemove': 'Remove 2FA',
      'admin.mfaModalTitle': 'Two-factor setup for {{name}}',
      'admin.mfaModalHint':
        'Scan the QR code with Google Authenticator or another TOTP app, then enter a code to confirm.',
      'admin.mfaQrLoading': 'Generating QR…',
      'admin.mfaVerifyPh': '6-digit code',
      'admin.mfaConfirm': 'Confirm',
      'admin.mfaCancel': 'Cancel',
      'mfa.code': 'Authenticator code',
      'mfa.codePh': '6-digit code',
      'mfa.loginHint': 'Enter the code from your authenticator app.',
      'mfa.back': 'Back',
      'admin.tabUsers': 'Users',
      'admin.tabTokens': 'Swap tokens',
      'admin.tabPools': 'Swap pairs',
      'admin.swapTokensHint':
        'Tokens are seeded on server startup from built-in lists. Import ERC-20s by contract below; use Sync chain to refresh symbol/name/decimals. Native entries cannot be synced from a contract.',
      'admin.swapTokenFromContract': 'Import from contract (chain + 0x address)',
      'admin.swapSymbol': 'Symbol',
      'admin.swapName': 'Name',
      'admin.swapDecimals': 'Decimals',
      'admin.swapTokenImport': 'Import',
      'admin.swapColAddress': 'Address',
      'admin.swapColEnabled': 'On',
      'admin.swapColToken0': 'Token0',
      'admin.swapColToken1': 'Token1',
      'admin.swapPoolFilterChain': 'Chain',
      'admin.swapPoolAllChains': 'All chains',
      'admin.swapPoolFilterPair': 'Trading pair',
      'admin.swapPoolAllPairs': 'All pairs',
      'admin.swapPoolRefresh': 'Refresh',
      'admin.swapPoolRefreshing': 'Refreshing…',
      'admin.swapColFee': 'Fee',
      'admin.swapSource': 'Source',
      'admin.swapSyncChain': 'Sync chain',
      'admin.swapEnable': 'Enable',
      'admin.swapDisable': 'Disable',
      'admin.swapDelete': 'Delete',
      'admin.swapChainCol': 'Chain',
      'admin.swapPoolsHint':
        'Liquidity pools are not pre-seeded. Add chain + token0 + token1, then scan; the backend queries configured DEX registries and upserts discovered pools.',
      'admin.swapPoolCreate': 'Auto scan pair pools',
      'admin.swapPoolIn': 'token0 (choose or input native/hex)',
      'admin.swapPoolOut': 'token1 (choose or input native/hex)',
      'admin.swapPoolFeeTier': 'fee tier (v3, e.g. 3000)',
      'admin.swapPoolFactoryPh': 'factory 0x…',
      'admin.swapPoolRouterPh': 'router (v2)',
      'admin.swapPoolQuoterPh': 'quoter (v3)',
      'admin.swapPoolSortPh': 'sort order',
      'admin.swapPoolSave': 'Scan and save',
      'admin.swapPoolSyncAddr': 'Sync pool addr',
      'admin.swapColProtocol': 'DEX',
      'admin.swapColPool': 'Pool',
      'common.error': 'Something went wrong.',
      'common.language': 'Language',
      'common.yes': 'Yes',
      'common.no': 'No',
    },
  },
  zh: {
    translation: {
      'lang.en': 'English',
      'lang.zh': '中文',
      'user.title': '用户登录',
      'user.login': '登录',
      'user.mustChange': '首次登录必须修改密码。',
      'user.updatePwd': '更新密码',
      'user.username': '用户名',
      'user.password': '密码',
      'user.newPassword': '新密码',
      'user.signedIn': '登录成功。',
      'user.changedOk': '密码已更新，请重新登录。',
      'user.logout': '退出',
      'home.title': '我的钱包',
      'home.loading': '加载中…',
      'home.forbiddenAdmin': '钱包主页仅供普通用户使用。请退出后使用用户账号登录。',
      'home.walletListSubtitle': '当前账号下的钱包列表。',
      'home.walletEmptyHint': '在下方创建第一个钱包。若尚未设置支付密码，请先到「个人设置」。',
      'home.settingsLink': '个人设置',
      'home.addWalletFold': '添加钱包',
      'home.createModeNew': '生成新钱包',
      'home.createModeImport': '导入私钥',
      'home.importKeyPh': '私钥（32 字节 hex，可有 0x 前缀）',
      'home.importKeyRequired': '请填写要导入的私钥。',
      'home.needPaymentGoSettings': '请先在「个人设置」中设置支付密码，再创建钱包。',
      'home.openSettings': '前往个人设置',
      'home.walletNoEvmAddr': '—',
      'home.copyEvmAddress': '复制地址',
      'home.evmAddressCopied': '已复制',
      'home.copyFailed': '复制失败。请手动选中地址复制，或使用 HTTPS 访问本页。',
      'home.source.stub': '占位',
      'home.source.mpc': 'mpc',
      'home.source.import': '导入',
      'home.stubSection': '开发：占位钱包',
      'home.stubHint': '在服务端配置中启用 wallet.mpc_stub。非真实密码学。',
      'home.stubName': '钱包名称',
      'home.createStub': '创建占位钱包',
      'home.createWalletTitle': '新建钱包',
      'home.createWalletHint': '为钱包起一个名字。密钥在您的浏览器内安全生成。',
      'home.createWalletNamePh': '钱包名称',
      'home.createWalletPayPh': '支付密码',
      'home.createWalletSubmit': '创建钱包',
      'home.creatingWallet': '正在创建…',
      'home.walletCreatedOk': '钱包已创建。',
      'home.walletCreatedFull': '创建成功。「{{name}}」已在下方列表中显示。',
      'home.walletNameRequired': '请填写钱包名称。',
      'home.walletListEmpty': '暂无钱包',
      'home.showHiddenWallets': '显示隐藏钱包',
      'home.walletHideFromHomeList': '从主页列表隐藏',
      'home.walletActions': '钱包操作',
      'home.walletMoveTop': '置顶',
      'home.walletMoveBottom': '置底',
      'home.walletHiddenBadge': '已隐藏',
      'home.walletAllHiddenInList': '当前所有钱包均在主页列表中隐藏。',
      'home.walletAllHiddenHint': '请勾选上方的「显示隐藏钱包」查看。',
      'home.mpcDisabledHint': '暂时无法创建钱包。若持续出现请联系支持。',
      'home.walletName': '钱包名称',
      'home.refresh': '刷新',
      'wallet.backHome': '返回钱包',
      'wallet.invalidId': '钱包链接无效。',
      'wallet.evmAddress': 'EVM 地址',
      'wallet.rippleAddress': 'Ripple 地址',
      'wallet.xrpBalance': 'XRP 余额',
      'wallet.ripple.disableMasterKey': 'DisableMasterKey',
      'wallet.ripple.regularKeyOnLedger': 'RegularKey（链上）',
      'wallet.rippleUnavailable': '该钱包当前无 Ripple 地址。',
      'wallet.type': '钱包类型',
      'wallet.type.evm': 'EVM',
      'wallet.type.ripple': 'Ripple',
      'wallet.type.bitcoin': 'Bitcoin',
      'wallet.bitcoinComingSoon': 'Bitcoin 功能即将支持。',
      'wallet.ripple.transferTitle': '转账',
      'wallet.ripple.sourceAddress': '转出源地址（可选）',
      'wallet.ripple.sourceAddressPh': '留空则使用当前钱包地址',
      'wallet.ripple.destination': '收款地址',
      'wallet.ripple.amountXrp': '数量（XRP）',
      'wallet.ripple.destinationTag': '目标 Tag',
      'wallet.ripple.optional': '可选',
      'wallet.ripple.paymentPassword': '支付密码',
      'wallet.ripple.transferSubmit': '签名并提交转账',
      'wallet.ripple.setRegularKeyTitle': '设置 RegularKey',
      'wallet.ripple.regularKey': 'RegularKey 地址',
      'wallet.ripple.setRegularKeySubmit': '签名并设置 RegularKey',
      'wallet.ripple.disableMasterTitle': '禁用 MasterKey',
      'wallet.ripple.disableMasterHint': '需先在链上设置 RegularKey。',
      'wallet.ripple.disableMasterSubmit': '签名并禁用 MasterKey',
      'wallet.ripple.submitting': '提交中…',
      'wallet.ripple.payPwdRequired': '请输入支付密码。',
      'wallet.ripple.destinationRequired': '请输入收款地址。',
      'wallet.ripple.amountRequired': '请输入 XRP 数量。',
      'wallet.ripple.regularKeyRequired': '请输入 RegularKey 地址。',
      'wallet.ripple.tagInvalid': '目标 Tag 必须是 uint32 整数。',
      'wallet.ripple.submitted': 'Ripple 交易已提交。',
      'wallet.ripple.txHash': '交易哈希',
      'wallet.renamePlaceholder': '新钱包名称',
      'wallet.renameSubmit': '修改名称',
      'wallet.renameBusy': '修改中…',
      'wallet.renameRequired': '请填写钱包名称。',
      'wallet.renameSuccess': '钱包名称已更新。',
      'wallet.renameDoubleClickHint': '双击可修改名称',
      'wallet.watchedTokens': '关注的代币',
      'wallet.watchedHint':
        '先选链：输入框留空表示该链原生代币；点 ▾ 从目录选择；或直接粘贴 ERC-20 合约地址。服务端通过每条链配置的多个公共 RPC 查询余额（见 config.yaml）；每次请求随机选两个节点并发查询以提高可用性。',
      'wallet.addToken': '添加',
      'wallet.contractChainLabel': '网络',
      'wallet.tokenOrContractLabel': '代币或合约地址',
      'wallet.tokenComboboxPh': '留空 = 原生币 · ▾ 目录 · 或 0x + 40 位 hex',
      'wallet.openTokenCatalog': '打开代币目录',
      'wallet.catalogEmptyForChain': '该链目录内代币已全部关注。',
      'wallet.catalogNoMatch': '目录无匹配 — 可输入合约地址或清空筛选。',
      'wallet.tokenInputInvalid': '请输入有效的非零 40 位十六进制地址（可有 0x）、从目录选择，或留空添加原生币。',
      'wallet.pickedTokenStale': '当前选择与网络不一致，请重新选择或输入地址。',
      'wallet.tokenAdded': '已加入关注列表。',
      'wallet.tokenRemoved': '已取消关注。',
      'wallet.colTokenChain': '代币 / 链',
      'wallet.colBalance': '余额',
      'wallet.balanceLoading': '加载中…',
      'wallet.refreshBalances': '刷新余额',
      'wallet.watchedListLoading': '正在加载关注列表…',
      'wallet.colActionSr': '操作',
      'wallet.noTokensYet': '暂无关注代币，请在上方添加。',
      'wallet.remove': '取消关注',
      'wallet.explorerTitle': '在区块浏览器中打开',
      'wallet.explorerHint': '选择网络。同一地址在各 EVM 链上通用。',
      'wallet.qr.scanWalletConnect': '扫描 WalletConnect 二维码',
      'wallet.qr.scanHint': '使用摄像头扫描 dApp 提供的 WalletConnect 二维码。',
      'wallet.qr.manualInput': 'WalletConnect URI（手动输入）',
      'wallet.qr.confirmWalletConnect': '执行 WalletConnect 配对',
      'wallet.qr.walletConnectInvalid': 'WalletConnect URI 无效，必须以 wc: 开头。',
      'wallet.qr.walletConnectDetected': '已识别并完成 WalletConnect 配对。',
      'wallet.qr.walletConnectProjectMissing':
        '缺少 WalletConnect 项目 ID，请在 web/.env.production 中配置 VITE_WALLETCONNECT_PROJECT_ID 后重新构建。',
      'wallet.qr.walletConnectPairFailed': 'WalletConnect 配对失败，请重试或更换二维码。',
      'wallet.qr.walletConnectSessionTitle': 'WalletConnect 会话请求',
      'wallet.qr.walletConnectSessionHint': '请确认 dApp 信息与申请权限后再授权。',
      'wallet.qr.walletConnectDapp': 'dApp',
      'wallet.qr.walletConnectMethods': '申请方法',
      'wallet.qr.walletConnectChains': '将授权的链',
      'wallet.qr.walletConnectActiveChain': '本会话活跃链',
      'wallet.qr.walletConnectActiveChainHint':
        'dApp 会把该链视为当前链；之后也可通过 wallet_switchEthereumChain 请求切换。',
      'wallet.qr.walletConnectNoSupportedChains':
        '该 dApp 要求的链当前钱包不支持。请拒绝会话，或在支持的网络上重新连接。',
      'wallet.qr.walletConnectChainSwitched': '已切换本 WalletConnect 会话的活跃链。',
      'wallet.qr.walletConnectChainUnsupported': '目标链不受支持，或不在本会话已授权链列表中。',
      'wallet.qr.walletConnectChainMismatch':
        '签名链不一致：typed data 的 domain.chainId 与 WalletConnect 请求链不匹配。请让 dApp 切链，或用正确的活跃链重新连接。',
      'wallet.qr.walletConnectSessionApproved': 'WalletConnect 会话已授权。',
      'wallet.qr.walletConnectSessionRejected': 'WalletConnect 会话已拒绝。',
      'wallet.qr.walletConnectSessionApproveFailed': '处理 WalletConnect 会话请求失败。',
      'wallet.qr.walletConnectRequestTitle': 'WalletConnect 签名请求',
      'wallet.qr.walletConnectRequestPayload': '签名原文（raw）',
      'wallet.qr.walletConnectRequestApproved': 'WalletConnect 请求已签名并返回。',
      'wallet.qr.walletConnectRequestRejected': 'WalletConnect 请求已拒绝。',
      'wallet.qr.walletConnectRequestApproveFailed': 'WalletConnect 请求签名失败。',
      'wallet.qr.walletConnectMethodUnsupported': '当前钱包暂不支持该 WalletConnect 方法。',
      'wallet.qr.reject': '拒绝',
      'wallet.qr.approve': '授权',
      'wallet.qr.approveAndSign': '授权并签名',
      'wallet.qr.cameraStartFailed': '无法启动摄像头扫码，请检查权限或手动粘贴 wc URI。',
      'wallet.close': '关闭',
      'tokenDetail.backWallet': '返回钱包',
      'tokenDetail.badRoute': '代币链接无效。',
      'tokenDetail.nativeLabel': '原生币',
      'tokenDetail.metaTitle': '代币信息',
      'tokenDetail.name': '名称',
      'tokenDetail.symbol': '符号',
      'tokenDetail.decimals': '精度',
      'tokenDetail.contract': '合约地址',
      'tokenDetail.nativeNoContract': '—（原生 gas 代币）',
      'tokenDetail.balance': '余额',
      'tokenDetail.usdPrice': '美元价格',
      'tokenDetail.usdPriceLoading': '加载中…',
      'tokenDetail.allowanceTitle': '授权额度',
      'tokenDetail.allowanceHint':
        '所选 spender 合约可从本钱包转走的代币数量。默认 spender 为应用内 Exchange 合约（各支持链上地址相同）。',
      'tokenDetail.refreshAllowance': '刷新',
      'tokenDetail.spender': 'Spender（合约）',
      'tokenDetail.approveTitle': '授权 Approve',
      'tokenDetail.approveUnlimited': '无限授权（最大 uint256）',
      'tokenDetail.approveAmountPh': '授权数量（代币单位）',
      'tokenDetail.approveAmountRequired': '请输入数量或勾选无限授权。',
      'tokenDetail.approveSubmit': '签名并提交授权',
      'tokenDetail.approveOk': '授权交易已提交。',
      'tokenDetail.wrapTitle': '封装（存入原生币）',
      'tokenDetail.wrapHint': '向封装合约发送原生币以接收封装 ERC-20（如 ETH → WETH）。',
      'tokenDetail.wrapAmountPh': '封装数量（如 0.1）',
      'tokenDetail.wrapSubmit': '签名并封装',
      'tokenDetail.wrapOk': '封装交易已提交。',
      'tokenDetail.unwrapTitle': '解封（取回原生币）',
      'tokenDetail.unwrapHint': '销毁封装代币以取回该链的原生币。',
      'tokenDetail.unwrapAmountPh': '解封数量',
      'tokenDetail.unwrapSubmit': '签名并解封',
      'tokenDetail.unwrapOk': '解封交易已提交。',
      'tokenDetail.submitting': '签名中…',
      'wallet.chain.ethereum': 'Ethereum',
      'wallet.chain.sepolia': 'Sepolia 测试网',
      'wallet.chain.bsc': 'BNB 智能链',
      'wallet.chain.base': 'Base',
      'wallet.chain.avax': 'Avalanche C-Chain',
      'wallet.chain.polygon': 'Polygon',
      'wallet.chain.arb': 'Arbitrum One',
      'wallet.chain.op': 'Optimism',
      'wallet.chain.ripple': 'Ripple',
      'wallet.chain.bitcoin': 'Bitcoin',
      'swap.nav': '兑换',
      'swap.title': '兑换询价',
      'swap.subtitle':
        '选择钱包、网络及目录中的代币。服务端按链查询多家主流 DEX（Uniswap V2 风格路由、V3 QuoterV2、以及已部署链上的 Uniswap V4 Quoter）。无流动性的路由会在对应行显示错误。',
      'swap.backHome': '返回钱包',
      'swap.selectWallet': '钱包',
      'swap.walletPlaceholder': '请选择钱包…',
      'swap.chain': '网络',
      'swap.tokenIn': '卖出',
      'swap.tokenOut': '买入',
      'swap.amountIn': '卖出数量',
      'swap.sellBalance': '余额',
      'swap.sellBalanceLoading': '正在加载余额…',
      'swap.slippage': '滑点',
      'swap.slippageBps': '{{bps}} 基点（100 = 1%）',
      'swap.slippageHint': '用于计算每条报价的最小到手量（min out）。',
      'swap.getQuote': '获取报价',
      'swap.quoting': '查询中…',
      'swap.quoteOk': '报价已更新。',
      'swap.resultsTitle': '各 DEX 对比',
      'swap.gasPrice': '建议 gas 价格',
      'swap.amountInSummary': '数量',
      'swap.colProtocol': '协议',
      'swap.colOut': '预计兑入',
      'swap.colMinOut': '滑点后最少兑入',
      'swap.colLiquidity': '流动性',
      'swap.colNote': '说明 / 错误',
      'swap.openPoolInExplorer': '在区块浏览器查看流动性池合约',
      'swap.colAction': '操作',
      'swap.swapExecute': '兑换',
      'swap.swapBusy': '签名中…',
      'swap.payPassword': '支付密码',
      'swap.payPasswordHint': '在浏览器内通过 MPC 签名兑换交易时需要。',
      'swap.payPasswordRequired': '请先填写支付密码再兑换。',
      'swap.swapSubmitted': '兑换交易已提交。',
      'swap.swapFeeRow': '交易 gas（Gwei）',
      'swap.swapCannotRow': '该行无可用报价，无法兑换。',
      'transfer.nav': '转账',
      'transfer.title': '转账',
      'transfer.subtitle': '选择钱包、网络、收款地址与代币。应用会先生成 EIP-1559 交易摘要，在浏览器内用 MPC 签名，再由后端提交到链上。',
      'transfer.backHome': '返回钱包',
      'transfer.selectWallet': '钱包',
      'transfer.walletPlaceholder': '请选择钱包…',
      'transfer.chain': '网络',
      'transfer.toAddress': '收款地址',
      'transfer.token': '代币',
      'transfer.amount': '数量',
      'transfer.balance': '余额',
      'transfer.balanceLoading': '正在加载余额…',
      'transfer.maxFee': '最大 gas 费（Gwei）',
      'transfer.priorityFee': '优先 gas 费（Gwei）',
      'transfer.baseFeeLine': '当前基础 gas 费：{{gwei}} Gwei',
      'transfer.nonce': '交易序号 (nonce)',
      'transfer.nonceHint': '默认从网络按当前钱包与链自动获取，也可自行修改。',
      'transfer.nonceInvalid': 'nonce 无效，请填写非负整数。',
      'transfer.nonceLoadError': '无法获取建议的 nonce。',
      'transfer.paymentPassword': '支付密码',
      'transfer.payPwdUnlockHint': '当前登录会话已验证支付密码，可留空复用。',
      'transfer.paymentPasswordRequired': '请输入支付密码。',
      'transfer.sessionMissing': '当前设备缺少该钱包的客户端会话。',
      'transfer.sessionInvalid': '钱包客户端会话数据无效。',
      'transfer.submit': '提交转账',
      'transfer.submitting': '提交中…',
      'transfer.submitted': '转账已提交。',
      'transfer.txHash': '交易哈希',
      'transfer.txJsonTitle': '已构造交易（未签名）',
      'transfer.txJsonHint': '由服务端返回的 EIP-1559 字段与待签名摘要。签名在浏览器内由 MPC 完成。',
      'proxyTransfer.nav': '代理转账',
      'proxyTransfer.title': '代理转账（EIP-7702）',
      'proxyTransfer.subtitle':
        '在单笔 EIP-7702（type-4）交易中完成多币种原子转出。从当前网络的代币目录中选择，填写源 EOA 私钥（仅在浏览器内签名用，不上传服务端），数量可留空则由服务端按链上余额补全。',
      'proxyTransfer.sourceKey': '源地址私钥',
      'proxyTransfer.sourceKeyPh': '0x…（64 位十六进制）',
      'proxyTransfer.toPlaceholder': '留空则使用当前钱包地址',
      'proxyTransfer.toDefaultHint': '留空时默认收款地址为当前钱包：{{address}}',
      'proxyTransfer.keyWarning': '请勿泄露私钥。仅在当前浏览器标签页用于签名，不会发往服务器。',
      'proxyTransfer.rowsTitle': '转出代币',
      'proxyTransfer.addRow': '添加一行',
      'proxyTransfer.noWatched': '当前网络暂无可用代币目录。',
      'proxyTransfer.amountOptional': '数量（可选）',
      'proxyTransfer.amountPlaceholder': '留空则转出全部余额',
      'proxyTransfer.removeRow': '删除',
      'proxyTransfer.privateKeyInvalid': '请输入有效的 32 字节十六进制私钥。',
      'proxyTransfer.needRow': '请至少保留一行代币。',
      'proxyTransfer.authNonceMissing': '无法获取源地址 nonce，无法生成委托授权。',
      'proxyTransfer.authNonceHint': '委托授权 nonce（源地址）: {{nonce}}',
      'proxyTransfer.submitting': '签名并提交中…',
      'proxyTransfer.submit': '签名并提交',
      'proxyTransfer.submitted': '代理转账已提交。',
      'proxyTransfer.lastPrepare': '最近一次准备响应（签名失败时）',
      'settings.title': '个人设置',
      'settings.back': '返回钱包',
      'settings.loginPwdTitle': '登录密码',
      'settings.loginPwdHint': '用于登录本账号。修改后仍保持当前登录状态。',
      'settings.newLoginPwdPh': '新登录密码',
      'settings.saveLoginPwd': '更新登录密码',
      'settings.loginPwdSaved': '登录密码已更新。',
      'settings.payTitle': '支付密码',
      'settings.payIntro': '仅在本机用于加密钱包密钥；服务端只保存安全哈希，不保存明文密码。',
      'settings.payIntroFirst':
        '请设置支付密码，用于在浏览器内加密钱包密钥。创建钱包前必须先完成设置；服务端不会保存明文密码。',
      'settings.payFirstBanner': '您尚未设置支付密码。请在此完成设置后返回钱包页创建钱包。',
      'settings.payCurrentPh': '当前支付密码',
      'settings.payNewPh': '新支付密码',
      'settings.paySetPh': '支付密码',
      'settings.payConfirmPh': '再次输入以确认',
      'settings.payMismatch': '两次输入的密码不一致。',
      'settings.savePayPwd': '保存支付密码',
      'settings.savePayPwdFirst': '设置支付密码',
      'settings.payPwdSaved': '支付密码已保存。',
      'settings.payPwdSavedFirst': '支付密码已设置，现在可以创建钱包了。',
      'settings.payReencryptSessionFailed': '无法从服务端加载加密的钱包数据。',
      'settings.payReencryptMissingSecret': '服务端钱包数据不完整，请联系支持。',
      'settings.payReencryptFail': '无法用当前支付密码解密钱包数据，请确认当前密码是否正确。',
      'admin.title': '管理后台',
      'admin.loginTitle': '管理员登录',
      'admin.login': '登录',
      'admin.mustChange': '首次登录必须修改管理员密码。',
      'admin.updatePwd': '更新密码',
      'admin.adminPwd': '管理员密码',
      'admin.newPassword': '新密码',
      'admin.userList': '用户列表',
      'admin.addUser': '新增用户',
      'admin.initialPwd': '初始密码',
      'admin.create': '创建用户',
      'admin.logout': '退出',
      'admin.goUser': '用户登录',
      'admin.thId': 'ID',
      'admin.thUser': '用户名',
      'admin.thRole': '角色',
      'admin.thMust': '需改密',
      'admin.thCreated': '创建时间',
      'admin.roleAdmin': '管理员',
      'admin.roleUser': '用户',
      'admin.thBanned': '封禁',
      'admin.actions': '操作',
      'admin.ban': '封禁',
      'admin.unban': '解除封禁',
      'admin.resetPwd': '重置密码',
      'admin.resetPwdTitle': '重置用户 {{name}} 的密码',
      'admin.resetPwdHint': '新密码',
      'admin.resetPwdSubmit': '保存',
      'admin.resetPwdCancel': '取消',
      'admin.thMfa': '两步验证',
      'admin.mfaSetup': '设置两步验证',
      'admin.mfaRemove': '关闭两步验证',
      'admin.mfaModalTitle': '为 {{name}} 设置两步验证',
      'admin.mfaModalHint': '使用谷歌身份验证器或其他 TOTP 应用扫描二维码，然后输入验证码完成绑定。',
      'admin.mfaQrLoading': '正在生成二维码…',
      'admin.mfaVerifyPh': '6 位验证码',
      'admin.mfaConfirm': '确认绑定',
      'admin.mfaCancel': '取消',
      'mfa.code': '身份验证器验证码',
      'mfa.codePh': '6 位验证码',
      'mfa.loginHint': '请输入身份验证器中显示的验证码。',
      'mfa.back': '返回',
      'admin.tabUsers': '用户',
      'admin.tabTokens': '兑换代币',
      'admin.tabPools': '交易币对',
      'admin.swapTokensHint':
        '服务端启动时会将内置代币列表写入数据库。下方可按合约地址导入 ERC-20；「链上同步」可刷新符号/名称/精度。原生币不能通过合约同步。',
      'admin.swapTokenFromContract': '从合约导入（网络 + 0x 地址）',
      'admin.swapSymbol': '符号',
      'admin.swapName': '名称',
      'admin.swapDecimals': '精度',
      'admin.swapTokenImport': '导入',
      'admin.swapColAddress': '地址',
      'admin.swapColEnabled': '启用',
      'admin.swapColToken0': 'Token0',
      'admin.swapColToken1': 'Token1',
      'admin.swapPoolFilterChain': '按链筛选',
      'admin.swapPoolAllChains': '全部链',
      'admin.swapPoolFilterPair': '交易币对',
      'admin.swapPoolAllPairs': '全部币对',
      'admin.swapPoolRefresh': '刷新',
      'admin.swapPoolRefreshing': '刷新中…',
      'admin.swapColFee': '费率',
      'admin.swapSource': '来源',
      'admin.swapSyncChain': '链上同步',
      'admin.swapEnable': '启用',
      'admin.swapDisable': '停用',
      'admin.swapDelete': '删除',
      'admin.swapChainCol': '链',
      'admin.swapPoolsHint':
        '流动性池不会随服务启动自动写入。请填写链 + token0 + token1 后执行扫描；后端会按已配置 DEX 注册表链上查询并写入池信息。',
      'admin.swapPoolCreate': '自动扫描币对池',
      'admin.swapPoolIn': 'token0（可选或手输 native/hex）',
      'admin.swapPoolOut': 'token1（可选或手输 native/hex）',
      'admin.swapPoolFeeTier': '费率档（v3，如 3000）',
      'admin.swapPoolFactoryPh': 'factory 0x…',
      'admin.swapPoolRouterPh': 'router（v2）',
      'admin.swapPoolQuoterPh': 'quoter（v3）',
      'admin.swapPoolSortPh': '排序',
      'admin.swapPoolSave': '扫描并保存',
      'admin.swapPoolSyncAddr': '同步池地址',
      'admin.swapColProtocol': '协议',
      'admin.swapColPool': '池地址',
      'common.error': '出错了。',
      'common.language': '语言',
      'common.yes': '是',
      'common.no': '否',
    },
  },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem(STORAGE_KEY) ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: true },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
  document.documentElement.lang = lng.startsWith('zh') ? 'zh' : 'en';
});

document.documentElement.lang = i18n.language.startsWith('zh') ? 'zh' : 'en';

export default i18n;
